import { createBrowserHistory } from 'history';

const history = createBrowserHistory({ basename: '/' } as any);

export default history;